module.exports = __webpack_public_path__ + "static/media/Starbucks_analysis.5f4592e6.webp";